import theme from '../exports.module.scss';

const subscriptionRatingColours = {
  '0': theme.intentSuccess,
  '0.7': theme.intentWarning,
  '0.9': theme.intentDanger,
};

export default subscriptionRatingColours;
